import {Box, styled} from '@mui/material';

export const StyledBox = styled(Box)`
	${({theme}) => theme.breakpoints.up('lg')} {
		overflow-y: auto;
		max-height: calc(100vh - 148px);
	}
`;
